export const INT_URL = 'http://localhost/geebees-app-api/';
export const EXT_URL = 'https://geebeesapp.dibc.in/backend/';
export const API_PATH = 'api/';
export const UPLOAD_PATH = 'uploads/';
export const PUB_API_PATH = 'pub/';
export const USER_API_PATH = 'user/';
export const VERSION = '1.0.1';
export const CLIENT_API_PATH = 'client_api/';
